<template>
  <div>
    <div class="theme-loader">
      <div class="ball-scale">
        <div class="contain">
          <img src="../assets/loader.gif" />
        </div>
      </div>
    </div>
    <div id="pcoded" class="pcoded">
      <div class="pcoded-overlay-box"></div>
      <div class="pcoded-container navbar-wrapper">
        <navbar1 />

        <div class="pcoded-main-container">
          <div class="pcoded-wrapper">
            <navbar2 />

            <div class="pcoded-content">
              <div class="pcoded-inner-content">
                <div class="main-body">
                  <div class="page-wrapper" style="background: #fff;">
                    <div class="page-body">
                      <h4>Edit Opening</h4>
                      <h6>
                        Fields marked <span style="color: #ff0000;">*</span> are
                        important.
                      </h6>
                      <form v-on:submit.prevent="createOpening">
                        <div class="form-group">
                          <label>Role: <span>*</span></label>
                          <roles
                            :model.sync="new_opening.role_id"
                            ref="roles"
                          />
                          <a
                            class="sub-text label label-primary label-sm"
                            href="javascript:void(0)"
                            data-target="#roles"
                            data-toggle="modal"
                          >
                            <i class="ti-plus"></i>
                            Add role
                          </a>
                        </div>
                        <div class="form-group">
                          <label for="job_location"
                            >Locations: <span>*</span></label
                          >
                          <div style="height: 200px; overflow-y: auto;">
                            <span
                              class="form-group"
                              v-for="location in locations"
                            >
                              <br />
                              <input
                                type="checkbox"
                                v-bind:value="location.id"
                                v-model="new_opening.location"
                              />
                              {{ location.city + ", " + location.state }}
                            </span>
                          </div>
                          <br />
                          <a
                            class="sub-text label label-primary label-sm"
                            href="javascript:void(0)"
                            data-target="#locations"
                            data-toggle="modal"
                          >
                            <i class="ti-plus"></i>
                            Add location
                          </a>
                        </div>
                        <div class="form-group">
                          <label for="qualification"
                            >Major Qualification: <span>*</span></label
                          >
                          <input
                            type="text"
                            id="qualification"
                            name="qualification"
                            v-model="new_opening.maj_qualification"
                            class="form-control"
                            required="required"
                            placeholder="e.g BSc Computer Science"
                            maxlength="200"
                          />
                        </div>
                        <div class="form-group">
                          <label for="required_skill"
                            >Required Skill: <span>*</span></label
                          >
                          <input
                            type="text"
                            id="required_skill"
                            name="required_skill"
                            v-model="new_opening.requiredskill"
                            class="form-control"
                            required="required"
                            placeholder="e.g Communication, MS Excel"
                            maxlength="200"
                          />
                        </div>
                        <div class="form-group">
                          <label for="extra_skill">Extra Skill:</label>
                          <input
                            type="text"
                            id="extra_skill"
                            name="extra_skill"
                            v-model="new_opening.extra_skill"
                            class="form-control"
                            placeholder="e.g Communication, MS Excel"
                            maxlength="200"
                          />
                        </div>
                        <div class="form-group">
                          <label for="max_age">Max Applicant Age:</label>
                          <input
                            type="number"
                            id="max_age"
                            name="max_age"
                            v-model="new_opening.max_age"
                            class="form-control"
                          />
                        </div>
                        <div class="form-group">
                          <label for="job_status"
                            >Job Status: <span>*</span></label
                          >
                          <select
                            id="job_status"
                            name="job_status"
                            v-model="new_opening.jobstatus"
                            class="form-control"
                            required="required"
                          >
                            <option value="" selected disabled="disabled"
                              >-</option
                            >
                            <option value="Contract Staff"
                              >Contract Staff</option
                            >
                            <option value="Subject to Confirmation"
                              >Subject to Confirmation</option
                            >
                            <option value="Full-Time Staff"
                              >Full-Time Staff</option
                            >
                            <option value="Apprentice">Apprentice</option>
                            <option value="Youth Corper">Youth Corper</option>
                            <option value="Industrial Attachment"
                              >Industrial Attachment</option
                            >
                            <option value="Political Appointee"
                              >Political Appointee</option
                            >
                            <option value="Pensioner">Pensioner</option>
                            <option value="Other Temporary Worker"
                              >Other Temporary Worker</option
                            >
                            <option value="Owner/C.E.O">Owner/C.E.O</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                              <label for="opening_date"
                                >Application Opening: <span>*</span></label
                              >
                              <input
                                type="date"
                                id="opening_date"
                                name="opening_date"
                                v-model="new_opening.entrydate"
                                class="form-control"
                                required="required"
                              />
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                              <label for="deadline"
                                >Application Deadline: <span>*</span></label
                              >
                              <input
                                type="date"
                                id="deadline"
                                name="deadline"
                                v-model="new_opening.last_applydate"
                                class="form-control"
                                required="required"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <label>Hiring Goal for Opening: <span>*</span></label>
                          <input
                            type="text"
                            name="available_slots"
                            v-model="new_opening.available_slots"
                            class="form-control"
                            maxlength="200"
                          />
                        </div>
                        <div class="form-group">
                          <label>Job Description <span>*</span></label>
                          <summernote
                            height="200"
                            ref="summer"
                            :model.sync="new_opening.jobdescription"
                          ></summernote>
                        </div>
                        <div class="form-group">
                          <label>Questions to Include:</label>
                          <br />
                          <div style="height: 300px; overflow-y: auto;">
                            <span v-for="question in questions">
                              <input
                                type="checkbox"
                                v-model="new_opening.question"
                                v-bind:value="question.id"
                              />
                              {{ question.question }}
                              <br />
                            </span>
                          </div>
                          <br />
                          <a
                            class="sub-text label label-primary label-sm"
                            href="javascript:void(0)"
                            data-target="#questions"
                            data-toggle="modal"
                          >
                            <i class="ti-plus"></i>
                            Add Question
                          </a>
                        </div>
                        <div class="form-group">
                          <input
                            type="submit"
                            class="btn btn-md btn-primary"
                            name="submit"
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="roles" class="modal fade" role="dialog">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Roles</h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body project-task">
            <div
              class="table table-responsive"
              style="width: 100%; max-height: 400px; overflow-y: auto;"
            >
              <table class="table">
                <thead>
                  <th>Roles</th>
                  <th>Action</th>
                </thead>
                <tbody>
                  <tr v-for="role in roles">
                    <td>{{ role.name }}</td>
                    <td>
                      <button
                        class="btn btn-primary btn-sm"
                        title="Edit (Not Implemented)"
                      >
                        <i class="ti-pencil"></i>
                      </button>
                      <button
                        class="btn btn-danger btn-sm"
                        title="Delete (Not Implemented)"
                      >
                        <i class="ti-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <form role="form" v-on:submit.prevent="addRole">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  name="New Role"
                  v-model="new_role.name"
                  required="required"
                  placeholder="Add New Role"
                />
              </div>
              <div class="form-group">
                <button class="btn btn-sm btn-primary">Add Role</button>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="locations" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Locations</h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body project-task">
            <div class="table table-responsive">
              <table class="table">
                <thead>
                  <!-- <th>Address</th> -->
                  <th>City</th>
                  <th>State</th>
                  <th>Country</th>
                  <th>Action</th>
                </thead>
                <tbody>
                  <div
                    style="width: 100%; display: contents;max-height: 200px; overflow-y: auto;"
                  >
                    <tr v-for="location in locations">
                      <!-- <td>{{location.address}}</td> -->
                      <td>{{ location.city }}</td>
                      <td>{{ location.state }}</td>
                      <td>{{ location.country }}</td>
                      <td>
                        <button
                          class="btn btn-danger btn-sm"
                          title="Delete"
                          v-on:click="$deleteItem(location.id, 'location')"
                        >
                          <i class="ti-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </div>

                  <tr>
                    <td colspan="4">
                      <form role="form" v-on:submit.prevent="addLocation">
                        <!-- <div class="form-group">
                                                    <input type="text" class="form-control" name="Address" v-model="new_location.address" required="required" placeholder="Address" />
                                                </div> -->
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            name="City"
                            v-model="new_location.city"
                            required="required"
                            placeholder="City"
                          />
                        </div>
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            name="State"
                            v-model="new_location.state"
                            required="required"
                            placeholder="State"
                          />
                        </div>
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            name="Country"
                            v-model="new_location.country"
                            required="required"
                            placeholder="Country"
                            readonly="readonly"
                          />
                        </div>
                        <div class="form-group">
                          <button class="btn btn-sm btn-primary">
                            Add Location
                          </button>
                        </div>
                      </form>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="questions" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Questions</h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body project-task">
            <div class="table table-responsive">
              <table class="table">
                <thead>
                  <th>Question</th>
                  <th>Required</th>
                  <th>Action</th>
                </thead>
                <tbody>
                  <div
                    style="width: 100%; display: contents;max-height: 200px; overflow-y: auto;"
                  >
                    <tr v-for="question in questions">
                      <td>{{ question.question }}</td>
                      <td>{{ question.required == "1" ? "Yes" : "No" }}</td>
                      <td>
                        <button class="btn btn-danger btn-sm" title="Delete">
                          <i class="ti-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </div>

                  <tr>
                    <td colspan="2">
                      <form role="form" v-on:submit.prevent="addQuestion">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            name="New Role"
                            v-model="new_question.question"
                            required="required"
                            placeholder="Add New Question"
                          />
                        </div>
                        <div class="form-group">
                          <label>Required?</label>
                          <select
                            class="form-control"
                            v-model="new_question.required"
                          >
                            <option value="1">Yes</option>
                            <option value="2">No</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <button class="btn btn-sm btn-primary">
                            Add Question
                          </button>
                        </div>
                      </form>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.sub-text {
  font-family: "Roboto";
  color: #ffa01b;
  font-weight: bold;
  margin-top: 20px;
  margin-left: 10px;
}
.form-group label {
  font-weight: bold !important;
}
.form-group input[type="checkbox"] {
  zoom: 1.5;
}
label span {
  color: #ff0000 !important;
}
ul li {
  list-style-type: disc !important;
  padding-left: auto !important;
}
</style>
<script>
import navbar1 from "../components/Navbar1.vue";
import navbar2 from "../components/Navbar2.vue";
import summernote from "../components/Summernote";
import roles from "../components/Roles";
import Request from "../request";

export default {
  name: "AddOpening",
  props: ["id"],

  data() {
    return {
      editor: "",
      old_opening: {
        requiredskill: "",
        jobcategory: "",
        role_id: "",
        maj_qualification: "",
        extra_skill: "",
        last_applydate: "",
        jobdescription: "",
        entrydate: "",
        location: [],
        jobstatus: "fresh",
        question: [],
        company_id: this.$store.getters.user_data.data.company_id,
        max_age: "",
        poster_id: this.$store.getters.user_data.data.id,
        expectedsalary: "",
        working_hours: "",
        available_slots: "",
      },
      new_opening: {},

      questions: [],
      roles: [],
      locations: [],
      new_role: {
        name: "",
      },
      new_location: {
        company_id: this.$store.getters.user_data.data.company_id,
        address: "null",
        city: "",
        state: "",
        country: "Nigeria",
      },
      new_question: {
        question: "",
        required: "",
      },
    };
  },

  components: {
    navbar1,
    navbar2,
    summernote,
    roles,
  },

  mounted() {
    this.getOpening();
    this.getQuestions();
    this.getRoles();
    this.getLocations();

    //console.log(this.$store.getters.user_data.data.company_id)
  },
  methods: {
    createOpening: function(e) {
      var opening = {
        what: "EditOpening",
        data: this.new_opening,
      };

    //   delete this.new_opening.jobdescription
    //   delete this.new_opening.questions;
    //   delete this.new_opening.locations;

      Request.makePostRequest(opening)
        .then((response) => {
          if (response.type == "EditOpening") {
            if (response.status == "true") {
              this.$swal.fire(
                "Success",
                "Opening edited successfully.",
                "success",
              );
              setTimeout(() => {
                window.location.href = "/openings";
              }, 2000);
            }
          }
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getQuestions: function() {
      var q = {
        what: "questions",
      };

      this.$socket
        .makeGetRequest(q)
        .then((response) => {
          if (response.type == "questions") {
            this.questions = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getOpening: function() {
      var q = {
        what: "getOpening",

        id: this.id,
      };

      this.$socket
        .makeGetRequest(q)
        .then((response) => {
          if (response.type == "getOpening") {
            this.old_opening = response.data;
            this.new_opening = this.old_opening;
            this.$refs.roles.getRoles();
            this.new_opening.location = this.new_opening.locations.map(
              (location) => location.id,
            );
            this.new_opening.question = this.new_opening.questions.map(
              (question) => question.id,
            );
            this.new_opening.role_id = this.new_opening.role_name;

             this.$refs.summer.setup(this.new_opening.jobdescription);
             console.log(this.new_opening.jobdescription)
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },

    getRoles: function() {
      var roles = {
        what: "roles",
        params: {
          company_id: this.$store.getters.user_data.data.company_id,
        },
      };

      //console.log(roles)
      Request.makeGetRequest(roles)
        .then((response) => {
          if (response.type == "roles") {
            this.roles = response.data;
            // this.new_opening.role_id = this.roles.find( role => role.name == this.new_opening.role_name).id
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getLocations: function() {
      var locations = {
        what: "locations",
        params: {
          company_id: this.$store.getters.user_data.data.company_id,
        },
      };

      Request.makeGetRequest(locations)
        .then((response) => {
          //console.log(response)
          if (response.type == "locations") {
            this.locations = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addRole: function() {
      var add_role = {
        what: "AddRole",
        data: {
          name: this.new_role.name,
          company_id: this.$store.getters.user_data.data.company_id,
        },
      };

      Request.makePostRequest(add_role)
        .then((response) => {
          if (response.type == "AddRole" && response.status == "true") {
            this.getRoles();
            this.$refs.roles.getRoles();
            this.new_role = "";
            this.$swal.fire("Success", "Role added.", "success");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addLocation: function() {
      var add_location = {
        what: "AddLocation",
        data: this.new_location,
      };

      Request.makePostRequest(add_location)
        .then((response) => {
          if (response.type == "AddLocation" && response.status == "true") {
            this.getLocations();
            window.alert("Location added.");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addQuestion: function() {
      var add_question = {
        what: "AddQuestion",
        data: this.new_question,
      };

      Request.makePostRequest(add_question)
        .then((response) => {
          if (response.type == "AddQuestion" && response.status == "true") {
            this.getQuestions();
            window.alert("Question added.");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    opening() {
      return old_opening;
    },

    // role_id () {
    //         this.new_opening.role_id = this.roles.find( role => role.name == this.new_opening.role_name);
    //         if(this.new_opening.role_id != undefined) {
    //             this.new_opening.role_id = this.new_opening.role_id.id
    //         }
    //         return this.new_opening.role_id
    //     // },

    //     // set (val) {
    //     //     this.new_opening.role_id = val
    //     // }
    // }
  },
};
</script>
